export const VersionNumber = "1.2026.7.2801";



// WEBPACK FOOTER //
// ./src/components/common/versionnumber.js